<template>
  <common-popup ref="commonPopup" :closeOnClickModal="true" :position="'top'">
    <img
      src="https://h5.yueyuechuxing.cn/yueyue/app_download/img/ios-prompt.813477aa.png"
      alt=""
    />
  </common-popup>
</template>

<script>
import CommonPopup from '@/components/CommonPopup';
export default {
  name: 'GuideOpen',
  components: {
    CommonPopup,
  },
  data() {
    return {};
  },
  methods: {
    show() {
      const dom = this.$refs.commonPopup;
      if (dom) {
        dom.show();
      }
    },
  },
};
</script>

<style lang="less" scoped>
img {
  width: 600px;
  margin-left: 140px;
}
</style>
